import React, {RefObject} from "react";
import "./TasksView.scss";
import JobSection from "../JobSection/JobSection";
import TasksSection from "../TasksSection/TasksSection";

interface OwnProps {
    headerReference: RefObject<HTMLHeadingElement>
    alert: React.ReactNode
}

const TasksView: React.FC<OwnProps> = (props: OwnProps): React.ReactElement => {
    const {headerReference, alert}: OwnProps = props;
    return (
        <div className="df-tasks-content">
            <div className="df-main-content">
                <JobSection headerReference={headerReference}/>
                <TasksSection headerReference={headerReference} alert={alert}/>
            </div>
        </div>
    );
};

export default TasksView;
